<template>
    <div>
        <strong class="menu-item">
            <a-list size="large" bordered :dataSource="menu">
                <a-list-item slot="renderItem" slot-scope="item, index" @click="route(index)" :style="{backgroundColor: (index == selectIndex ? 'gainsboro' : '') }">
                    <a-row type="flex" justify="start" align="middle" :style="{margin: '0px', padding: '0px'}">
                        <a-col class="gutter-row"><a-icon :key="index" :type="item.icon" /></a-col>
                        <a-col class="gutter-row">
                        <span style="margin-left: 10px">
                            {{item.text}}
                        </span>
                        </a-col>
                    </a-row>
                </a-list-item>
            </a-list>
        </strong>
        <HotSearch :style="{marginTop: '40px'}"/>
    </div>
</template>

<script>
    import HotSearch from "../content/search/HotSearch";

    export default {
        name: "MenuSetting",
        components: {HotSearch},
        props: ['defaultIndex'],
        watch:{
            defaultIndex(){
                this.selectIndex = this.defaultIndex;
            }
        },
        data() {
            return {
                selectIndex: this.defaultIndex,
                menu: [
                    {
                        text: '文章',
                        icon: 'file-text',
                        route: '/search/blog'
                    },
                    {
                        text: '用户',
                        icon: 'user',
                        route: '/search/user'
                    },
                    {
                        text: '专题',
                        icon: 'flag',
                        route: '/search/subject'
                    }
                ]
            }
        },
        methods: {
            route(index){
                let _this = this;
                _this.selectIndex = index;
                if (_this.$route.query.q) {
                    _this.$router.push(_this.menu[index].route.concat("?q=").concat(_this.$route.query.q));
                } else {
                    _this.$router.push(_this.menu[index].route);
                }
            }
        }
    }
</script>

<style scoped>
    .menu-item, .ant-list {
        font-size: 16px;
    }
    .ant-list-item:hover {
        background-color: gainsboro;
    }
    .pk-search-word:hover {
        background-color: gainsboro;
    }

</style>